import React from 'react'

import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

import { useSetRecoilState, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import { TruncateAndTooltip, Select } from 'mailup-web-components'

import {
  contentPositionState,
  contentPositionOptionsState
} from '../recoil/state'

import Thumb from './Thumb'

const ResultItem = styled.li`
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--silver);
`

const ColImage = styled.div`
  flex-basis: 8.333333%;
  max-width: 8.333333%;
  padding-right: 15px;
`

const ColTitle = styled.div`
  padding-right: 15px;
  ${({ image }) =>
    image
      ? `
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
      `
      : `
      flex: 0 0 75%;
      max-width: 75%;
      `}
`

const ColPosition = styled.div`
  flex: 0 0 25%;
`

const ResultTitle = styled(TruncateAndTooltip)`
  font-size: 15px;
  font-weight: 500;
  color: var(--boulder);
`

const ResultSummary = styled(TruncateAndTooltip)`
  font-size: 15px;
  font-weight: 400;
  color: var(--boulder);
`

const SearchContentsResult = ({ title, summary, contentKey, image }) => {
  const intl = useIntl()

  const changePosition = useSetRecoilState(contentPositionState(contentKey))

  const handleChangePosition = position => changePosition(position)

  const position = useRecoilValue(contentPositionState(contentKey))

  const positionOptions = useRecoilValue(
    contentPositionOptionsState(contentKey)
  )

  return (
    <ResultItem>
      {image && (
        <ColImage>
          <Thumb src={image} />
        </ColImage>
      )}

      <ColTitle image={image}>
        <ResultTitle text={title} />
        <ResultSummary text={summary} />
      </ColTitle>
      <ColPosition>
        <Select
          value={position}
          options={positionOptions}
          onChange={handleChangePosition}
          placeholder={intl.formatMessage({
            id: 'Load.BeeContentDialog.Select'
          })}
          searchable={false}
        />
      </ColPosition>
    </ResultItem>
  )
}

SearchContentsResult.propTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  contentKey: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default SearchContentsResult
